import * as fromDatatype from '../datatype-library';

export interface bl_wf_issue_to_issue_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_issue_1_hdr: fromDatatype.GuidDataFieldInterface;
  guid_issue_1_line: fromDatatype.GuidDataFieldInterface;
  start_date_issue_1_hdr: fromDatatype.TimestampTzDatatypeInterface;
  start_date_issue_1_line: fromDatatype.TimestampTzDatatypeInterface;
  end_date_issue_1_hdr: fromDatatype.TimestampTzDatatypeInterface;
  end_date_issue_1_line: fromDatatype.TimestampTzDatatypeInterface;
  guid_issue_2_hdr: fromDatatype.GuidDataFieldInterface;
  guid_issue_2_line: fromDatatype.GuidDataFieldInterface;
  start_date_issue_2_hdr: fromDatatype.TimestampTzDatatypeInterface;
  start_date_issue_2_line: fromDatatype.TimestampTzDatatypeInterface;
  end_date_issue_2_hdr: fromDatatype.TimestampTzDatatypeInterface;
  end_date_issue_2_line: fromDatatype.TimestampTzDatatypeInterface;
  txn_type: fromDatatype.TextDatatypeInterface;
  logic: fromDatatype.TextDatatypeInterface;
  option: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  date_txn: fromDatatype.TextDatatypeInterface;
  log_json: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
}

export class bl_wf_issue_to_issue_link_RowClass
  implements bl_wf_issue_to_issue_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_issue_1_hdr: fromDatatype.GuidDataFieldInterface;
  guid_issue_1_line: fromDatatype.GuidDataFieldInterface;
  start_date_issue_1_hdr: fromDatatype.TimestampTzDatatypeInterface;
  start_date_issue_1_line: fromDatatype.TimestampTzDatatypeInterface;
  end_date_issue_1_hdr: fromDatatype.TimestampTzDatatypeInterface;
  end_date_issue_1_line: fromDatatype.TimestampTzDatatypeInterface;
  guid_issue_2_hdr: fromDatatype.GuidDataFieldInterface;
  guid_issue_2_line: fromDatatype.GuidDataFieldInterface;
  start_date_issue_2_hdr: fromDatatype.TimestampTzDatatypeInterface;
  start_date_issue_2_line: fromDatatype.TimestampTzDatatypeInterface;
  end_date_issue_2_hdr: fromDatatype.TimestampTzDatatypeInterface;
  end_date_issue_2_line: fromDatatype.TimestampTzDatatypeInterface;
  txn_type: fromDatatype.TextDatatypeInterface;
  logic: fromDatatype.TextDatatypeInterface;
  option: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  date_txn: fromDatatype.TextDatatypeInterface;
  log_json: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
}
